import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { routePrefetchMap } from '../../utils/prefetchManager'
import { api} from '../../utils/variables'

const PrefetchManager = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // Prefetch data based on current route
    const prefetchFn = routePrefetchMap[location.pathname]
    if (prefetchFn) {
      // Small delay to ensure the current page loads first
      const timeoutId = setTimeout(() => {
        prefetchFn()
      }, 100)

      return () => clearTimeout(timeoutId)
    }
  }, [location.pathname])

  useEffect(() => {
    // Run onboarding check once per session when an auth token is available
    const alreadyChecked = sessionStorage.getItem('onboarding_checked') === 'true'
    const token = localStorage.getItem('authToken')
    if (alreadyChecked || !token) return

    const checkAndUpdateOnboarding = async () => {
      try {
        const statusRes = await axios.get(`${api}/user/onboarding/status`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json, text/plain, */*',
          },
        })

        const data = statusRes?.data || {}
        // If backend indicates AI screen was already shown, do nothing.
        const hasAiSeen = data.is_onboarded === true && data.onboarding_state && data.onboarding_state.ai_screen === true

        // If AI screen not seen, navigate to chatbot and set a session flag so the trial modal opens after chatbot is closed
        if (!hasAiSeen) {
          try {
            sessionStorage.setItem('show_trial_modal_after_ai', 'true')
          } catch (e) {}
          try {
            navigate('/chatbot', { state: { initialPrompt: 'Welcome me as a new user on keyquest and give a brief description about the platform?' } })
          } catch (e) {
            // ignore navigation errors
          }
        }
      } catch (err) {
        // ignore status check errors
      } finally {
        // mark as checked for this session to avoid repeated calls
        try { sessionStorage.setItem('onboarding_checked', 'true') } catch (e) {}
      }
    }

    // Run in background without blocking render
    checkAndUpdateOnboarding()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname])

  // This component doesn't render anything
  return null
}

export default PrefetchManager
